import React, { FC, memo } from 'react';
import { Button } from 'components/src';
import { Platform, createUseStyles, useLang } from 'core/src';

interface FloatButtonProps {
  children: React.ReactNode;
  onClick: () => void;
}

const FloatButton: FC<FloatButtonProps> = memo(({ children, onClick }) => {
  const { styles } = useStyles();
  const { lang } = useLang();
  return (
    <Button
      onClick={onClick}
      classes={[
        lang === 'fa-IR' ? styles.floatButtonLeft : styles.floatButtonRight,
        {
          marginHorizontal: Platform.isPwa || Platform.isDesktop ? 10 : 0,
        },
      ]}
    >
      {children}
    </Button>
  );
});

const useStyles = createUseStyles(({ colors, theme }) => ({
  floatButtonLeft: {
    left: 20,
    position: 'absolute',
    bottom: 35,
    height: 40,
    width: 40,
    borderRadius: 50,
    backgroundColor: theme === 'white' ? 'transparent' : colors.secondryColor,
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'flex-end',
    borderBottomWidth: theme === 'white' ? 1 : 0,
  },
  floatButtonRight: {
    right: 20,
    position: 'absolute',
    bottom: 35,
    height: 40,
    width: 40,
    borderRadius: 50,
    backgroundColor: theme === 'white' ? 'transparent' : colors.secondryColor,
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'flex-end',
    borderBottomWidth: theme === 'white' ? 1 : 0,
  },
}));

export { FloatButton };
